import BaseComponent from '../base_component/base_component'

export default class AjaxError extends BaseComponent {

    initialize() {
        this.errorCount = 0;
        this.find('.error-notification').click(() => {
            this.find('.error-container').show();
        })
    }

    functions() {
        return {
            handleAjaxError: this.addError.bind(this)
        }
    }

    close() {
        this.find('.error-container').hide();
    }

    addError(body, component) {
        this._injectError(body, component.name);
        this.find('.error-container style').remove();

        this.errorCount += 1;
        this.find('.error-notification .count').text(this.errorCount);
        this.find('.error-notification').show();
    }

    _injectError(body, name) {
        let id = `${this.id}_collapse${this.errorCount}`
        let template = `
            <div class="panel-heading">
            <h4 class="panel-title">
                <a data-toggle="collapse" data-parent="${this.id}_accordion" href="#${id}">
                    <span class=panel-title>${name.replace(/_/g, ' ')}</span>
                </a>
            </h4>
            </div>
            <div id="${id}" class="panel-collapse collapse${this.errorCount == 0 ? ' in' : ''}">
                <div class="panel-body">
                    ${body}
                </div>
            </div>
        `
        this.find('.panel-default').append(template);
    }
}